import $ from 'jquery'
import Rails from '@rails/ujs'
import Modal from '../src/visitor/components/Modal'
import Range from '../src/visitor/components/Range'

import '../stylesheets/visitor/application.scss'

import.meta.glob('../images/**/*')

if (!window._rails_loaded) {
  Rails.start()
}

$(() => $('.p-question__range').each((i, el) => { new Range({ el, rootClass: '.p-question' }) }))
$(() => $('.p-surveyPage__range').each((i, el) => { new Range({ el, rootClass: '.p-surveyPage' }) }))
$(() => $('.js-modal').each((i, el) => { new Modal({ el }) }))
